import { openDB } from 'idb';

export const getReportDB = async () => {
  return openDB('reports-cache', 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('reports')) {
        db.createObjectStore('reports');
      }
    },
  });
};

export const putReportInCache = async (route, data) => {
  const db = await getReportDB();
  const entry = { data, ts: Date.now() };
  await db.put('reports', entry, route);

  if (typeof BroadcastChannel !== 'undefined') {
    const bc = new BroadcastChannel('reports-cache');
    bc.postMessage({ route, entry });
    bc.close();
  }
};

export const getReportFromCache = async (route) => {
  const db = await getReportDB();
  return db.get('reports', route);
};

export const clearOldReports = async (maxAgeMs) => {
  const db = await getReportDB();
  const tx = db.transaction('reports', 'readwrite');
  const store = tx.objectStore('reports');

  const now = Date.now();
  let cursor = await store.openCursor();

  while (cursor) {
    const { ts } = cursor.value || {};
    if (!ts || now - ts > maxAgeMs) {
      await cursor.delete();
    }
    cursor = await cursor.continue();
  }

  await tx.done;
};
